document.addEventListener("DOMContentLoaded", function () {
    const toggle = document.getElementById("menu-toggle");
    const menu = document.getElementById("menu-menu-1");

    function openMenu() {
        toggle.setAttribute("aria-expanded", "true");
        menu.classList.add("is-active");
    }

    function closeMenu() {
        toggle.setAttribute("aria-expanded", "false");
        menu.classList.remove("is-active");
    }

    toggle.addEventListener("click", function () {
        const isOpen = toggle.getAttribute("aria-expanded") === "true";
        isOpen ? closeMenu() : openMenu();
    });

    // 👉 fermeture quand on sort du nav
    menu.addEventListener("mouseleave", function () {
        closeMenu();
    });

    const searchBtn = document.querySelector('#account .search');
    const formSearch = document.querySelector('.form-search');

    if (searchBtn && formSearch) {
        searchBtn.addEventListener('click', () => {
            formSearch.classList.toggle('active');
        });
    }
});


document.addEventListener("DOMContentLoaded", function () {

    if (!window.matchMedia("(max-width: 1024px)").matches) {
        console.log("ok menu stop");
        return; // stop si on n'est pas sur mobile

    }

    // Ouvre le menu principal (slide depuis la droite)
    const mainToggle = document.querySelector("#headernav .mobile.readmore");
    const mainNav = document.querySelector("#headernav .nav");

    mainToggle.addEventListener("click", function() {
        mainNav.classList.add("active");
    });

    // Gère le clic sur les catégories pour ouvrir les sous-menus
    const menuLinks = document.querySelectorAll("#headernav .nav > li > a:not(.back)");

    menuLinks.forEach(link => {
        link.addEventListener("click", function(e) {
            const submenu = this.parentElement.querySelector(".submenu");
            if (submenu) {
                e.preventDefault(); // empêche la navigation
                submenu.classList.add("active");
            }
        });
    });

    // Gère les liens "Retour" dans les sous-menus
    const backLinks = document.querySelectorAll("#headernav .back");

    backLinks.forEach(back => {
        back.addEventListener("click", function(e) {
            e.preventDefault();

            const submenu = this.closest(".submenu");
            if (submenu) {
                submenu.classList.remove("active");
            } else {
                // si on est sur le menu principal, ferme-le
                mainNav.classList.remove("active");
            }
        });
    });

});


/*document.addEventListener("DOMContentLoaded", function () {
    const telEl = document.querySelector('.section-hero--tel');
    if (!telEl) return;

    telEl.classList.add('is-hidden'); // caché par défaut

    window.addEventListener('scroll', function () {
        const scrollY = window.scrollY;
        const scrollBottom = window.innerHeight + window.scrollY;
        const documentHeight = document.documentElement.scrollHeight;

        const isAtBottom = (scrollBottom + 100 >= documentHeight); // marge de 100px
        const isScrolled = scrollY > 10;

        if (isScrolled && !isAtBottom) {
            telEl.classList.add('is-visible');
            telEl.classList.remove('is-hidden');
        } else {
            telEl.classList.remove('is-visible');
            telEl.classList.add('is-hidden');
        }
    });
});*/




document.addEventListener("DOMContentLoaded", function () {
    const telEl = document.querySelector('.up');
    if (!telEl) return;

    telEl.classList.add('is-hidden'); // caché par défaut

    window.addEventListener('scroll', function () {
        const scrollY = window.scrollY;

        if (scrollY > 1400) {
            telEl.classList.add('is-visible');
            telEl.classList.remove('is-hidden');
        } else {
            telEl.classList.remove('is-visible');
            telEl.classList.add('is-hidden');
        }
    });
});


// Animation

document.addEventListener("DOMContentLoaded", function () {
    const fadeEls = document.querySelectorAll(
        ".fade-in-left, .fade-in-right, .fade-in-top, .fade-in-bottom, .fade-in"
    );

    const appearOnScroll = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("fade-in-visible");
                    observer.unobserve(entry.target); // Animation une seule fois
                }
            });
        },
        {
            threshold: .5
        }
    );

    fadeEls.forEach(el => {
        appearOnScroll.observe(el);
    });
});


// Up
document.addEventListener("DOMContentLoaded", function () {
    const upButton = document.querySelector('.up');

    if (upButton) {
        upButton.addEventListener('click', function () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // pour un scroll fluide
            });
        });
    }
});



// Slider réalisations
document.addEventListener('DOMContentLoaded', function () {
    const swiperContent = new Swiper('.realisation-content-slider', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    const swiperPhoto = new Swiper('.realisation-photo-slider', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        effect: 'fade', // <- effet de fondu
        fadeEffect: {
            crossFade: true // fondu croisé
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    // Synchronisation des deux sliders
    swiperContent.controller.control = swiperPhoto;
    swiperPhoto.controller.control = swiperContent;
});


// Modal
// Récupère tous les boutons qui ouvrent une modal
const modalButtons = document.querySelectorAll("[data-modal]");

modalButtons.forEach(button => {
    const modalId = button.dataset.modal; // l'id de la modal à ouvrir
    const modal = document.getElementById(modalId);

    if (!modal) return;

    // Ouverture de la modal
    button.addEventListener("click", () => {
        modal.classList.add("open");
    });

    // Fermeture via le bouton close à l'intérieur
    const closeBtn = modal.querySelector(".closeBtn");
    if (closeBtn) {
        closeBtn.addEventListener("click", () => modal.classList.remove("open"));
    }

    // Fermeture en cliquant sur le fond
    modal.addEventListener("click", e => {
        if (e.target === modal) modal.classList.remove("open");
    });
});




// Product variation

// Btn personnalisation
document.addEventListener('DOMContentLoaded', function () {
    const select = document.querySelector('#personnalisation');
    const radioOui = document.querySelector('#thwvsf-radio-personnalisation-oui-0');
    const radioNon = document.querySelector('#thwvsf-radio-personnalisation-non-0');
    const labelOui = document.querySelector('label[for="thwvsf-radio-personnalisation-oui-0"]');
    const labelNon = document.querySelector('label[for="thwvsf-radio-personnalisation-non-0"]');

    if (!select || !radioOui || !radioNon || !labelOui || !labelNon) return;

    // 1️⃣ Par défaut, coche "non" dans radio ET select
    radioOui.checked = true;
    labelOui.classList.add('thwvsf-selected');
    select.value = 'oui';
    select.dispatchEvent(new Event('change', { bubbles: true }));

    // 2️⃣ Gestion du toggle sur "oui"
    labelOui.addEventListener('click', function(e) {
        e.preventDefault(); // empêche l'action native

        if (radioOui.checked) {
            // Décocher Oui → coche Non
            radioOui.checked = false;
            radioNon.checked = true;
            labelOui.classList.remove('thwvsf-selected');
            labelNon.classList.add('thwvsf-selected');

            // Mettre à jour le select WooCommerce
            select.value = 'non';
        } else {
            // Coche Oui → décoche Non
            radioOui.checked = true;
            radioNon.checked = false;
            labelOui.classList.add('thwvsf-selected');
            labelNon.classList.remove('thwvsf-selected');

            // Mettre à jour le select WooCommerce
            select.value = 'oui';
        }

        // Déclenche l'événement change pour que WooCommerce détecte la variation
        select.dispatchEvent(new Event('change', { bubbles: true }));
    });
});

// page avec blog gutengerg "sections"
document.addEventListener('DOMContentLoaded', () => {
    // Sélection des éléments
    const section = document.querySelector('.section-sections');
    const bullets = document.querySelectorAll('.sections-bullets .bullet');
    const items = document.querySelectorAll('.step');

    if (items.length && bullets.length) {
        // Activation de la section globale
        const toggleBulletsSection = () => {
            const sectionTop = section.getBoundingClientRect().top;
            if (sectionTop <= 100 && sectionTop + section.offsetHeight > 100) {
                section.querySelector('.sections-bullets').classList.add('active');
            } else {
                section.querySelector('.sections-bullets').classList.remove('active');
            }
        }

        window.addEventListener('scroll', toggleBulletsSection);
        toggleBulletsSection();
        // Activation des bullets selon les items
        const updateBullets = () => {
            items.forEach((item, index) => {
                const itemTop = item.getBoundingClientRect().top;
                if (itemTop <= 100 && itemTop + item.offsetHeight > 0) {
                    bullets.forEach(b => b.classList.remove('active'));
                    bullets[index].classList.add('active');
                }
            });
        }
        window.addEventListener('scroll', updateBullets);
        updateBullets();
    }
});


// Page produit : sticky réalisations


document.addEventListener('DOMContentLoaded', () => {
    // Sélection des éléments
    const section = document.querySelector('.woocommerce-transcom--realisations');
    const bullets = document.querySelectorAll('.realisation-bullets .bullet');
    const items = document.querySelectorAll('.item-rea');

    if (section && bullets.length) {

        // Activation de la section globale
        const toggleBulletsSection = () => {
            const sectionTop = section.getBoundingClientRect().top;

            if (sectionTop <= 100 && sectionTop + section.offsetHeight > 0) {
                section.querySelector('.realisation-bullets').classList.add('active');
            } else {
                section.querySelector('.realisation-bullets').classList.remove('active');
            }
        }

        window.addEventListener('scroll', toggleBulletsSection);
        toggleBulletsSection();

        // Activation des bullets selon les items
        const updateBullets = () => {
            items.forEach((item, index) => {
                const itemTop = item.getBoundingClientRect().top;

                if (itemTop <= 200 && itemTop + item.offsetHeight > 0) {
                    bullets.forEach(b => b.classList.remove('active'));
                    bullets[index].classList.add('active');
                }
            });
        }

        window.addEventListener('scroll', updateBullets);
        updateBullets();
    }
});






// Assurez-vous que GSAP et ScrollTrigger sont chargés





/*
const container = document.querySelector('.realisations-container');
const content = document.querySelector('.realisations-container-content');
document.addEventListener('DOMContentLoaded', () => {

    if (container && content) {

        setTimeout(() => {
           gsap.registerPlugin(ScrollTrigger);


            const titleEl = content.querySelector('h3');
            const descEl = content.querySelector('.realisation-description');
            const items = container.querySelectorAll('.item-rea');

            const bullets = document.querySelectorAll('.realisation-bullets .bullet');
            const headerOffset = 120;

            // Sticky pour la colonne gauche
            ScrollTrigger.create({
                trigger: container,
                pin: content,
                start: `top-=${headerOffset} top`,
                end: () => `+=${container.scrollHeight - content.offsetHeight}`,
                pinSpacing: true,
                scrub: true,
                markers: false
            });

            // Update du texte et des bullets
            items.forEach((item, index) => {
                const offset = content.offsetTop;

                ScrollTrigger.create({
                    trigger: item,
                    start: `top-=${headerOffset} top`,
                    onEnter: () => {
                        // Texte
                        titleEl.innerHTML = item.dataset.title;
                        descEl.innerHTML = item.dataset.description;

                        // Bullet
                        bullets.forEach(b => b.classList.remove('active'));
                        if (bullets[index]) bullets[index].classList.add('active');
                    },
                    onEnterBack: () => {
                        // Texte
                        titleEl.innerHTML = item.dataset.title;
                        descEl.innerHTML = item.dataset.description;

                        // Bullet
                        bullets.forEach(b => b.classList.remove('active'));
                        if (bullets[index]) bullets[index].classList.add('active');
                    },
                    markers: false
                });
            });

        }, 500); // délai pour attendre DOM + images
    }
});
*/

// Demande de devis
/*
const container2 = document.querySelector('.addify-quote-form');
const content2 = document.querySelector('.af_quote_fields');
const headerOffset2 = 120; // hauteur du header fixe

document.addEventListener('DOMContentLoaded', () => {
    if (container2 && content2) {
        ScrollTrigger.matchMedia({
            "(min-width: 1024px)": function () {
                ScrollTrigger.create({
                    trigger: container2,
                    pin: content2,
                    start: `top-=${headerOffset2} top`,
                    end: () => `+=${container2.scrollHeight - content2.offsetHeight}`,
                    pinSpacing: true,
                    scrub: true,
                    markers: false
                });
            }
        });
    }
});
*/

// Page produit : select
const selectElement = document.querySelector('select#thematique');
const galleryM = jQuery('.woocommerce-product-gallery');

if (selectElement) {
    document.querySelector('select#thematique').addEventListener('change', (e) => {

        e.stopImmediatePropagation?.(); // si jQuery n'est pas là, pas grave
        e.stopPropagation(); // bloque propagation standard
        e.preventDefault();  // empêche actions par défaut


        console.log(selectElement.value);
        const items = document.querySelectorAll('.thwvsf-wrapper-ul li');
        items.forEach(li => li.style.display = '');

        console.log(selectElement.selectedIndex);

        items.forEach(li => {
            const value = li.dataset.value; // équivalent de getAttribute('data-value')
            if (value.startsWith(selectElement.selectedIndex)) {
                li.style.display = ''; // afficher
            } else {
                li.style.display = 'none'; // cacher
            }
        });

        if(selectElement.selectedIndex == 0) {
            items.forEach(li => {
                li.style.display = ''; // afficher
            });
        }
    });

    document.querySelector('select#thematique').addEventListener('focus', () => {
        const modeleSelect = document.querySelector('select#modeles');
        const thematiqueSelect = document.querySelector('select#thematique');

        console.log(thematiqueSelect.value);

        if (modeleSelect) {
            // Déclencher les événements pour que le plugin se mette à jour
            modeleSelect.dispatchEvent(new Event('input', {bubbles: true}));
            modeleSelect.dispatchEvent(new Event('change', {bubbles: true}));
        }


    });
}

// Page produit : modèles - gestion des numéros

document.querySelectorAll(
    'body.single-product.has-product-modeles .variations .tbody .line-modeles .thwvsf-wrapper-item-li .th-sr-only'
).forEach(el => {

    const text = el.textContent.trim();

    if (!text) return;

    const words = text.split(' ');

    words[0] = `<span class="first-word">${words[0]}</span>`;

    el.innerHTML = words.join(' ');
});

// Page produit : règles
// Sélectionne tous les li dans ta ligne modèles
const lineModeles = document.querySelector('.line-modeles');
if (lineModeles) {
    const items = lineModeles.querySelectorAll('li');

    items.forEach((li, index) => {
        li.addEventListener('click', () => {

            const dynamicClass = `modele-${index + 1}`;

            // Retire la classe active de tous les éléments
            const lis = document.querySelectorAll('.section-transcom-modeles li');
            lis.forEach(li => li.classList.remove('active'));


            // Crée la classe dynamique et l'ajoute
            const target = document.querySelector(`.${dynamicClass}`);
            if (target) {
                target.classList.add('active');
            }

            console.log('Position dans la liste :', index + 1); // pour debug
            console.log('Classe ajoutée :', dynamicClass);
        });
    });
}

// Un seul produit par variation dans la demande de devis :
document.addEventListener('DOMContentLoaded', () => {

    // Vérifie si on est sur la page avec le formulaire Addify template_one
    const addifyForm = document.querySelector('.addify-quote-form.template_one');
    if (!addifyForm) return; // quitte si le formulaire n'existe pas

    // Fonction pour mettre toutes les quantités à 1 et supprimer le message vide
    const enforceSingleQuantity = () => {
        const items = [...addifyForm.querySelectorAll('.cart_item')];
        items.forEach(item => {
            const qtyInput = item.querySelector('input.qty');
            if (qtyInput.value > 1) {
                qtyInput.value = 1;
                // Déclenche le change après un petit délai pour que Addify ait attaché ses listeners
                setTimeout(() => {
                    const event = new Event('change', { bubbles: true });
                    qtyInput.dispatchEvent(event);
                }, 60); // tu peux ajuster si besoin
            }
        });

    };

    // On applique au chargement avec un petit délai
    setTimeout(enforceSingleQuantity, 100); // laisse Addify finir l'initialisation

    // On applique après toute mise à jour du devis
    document.addEventListener('updated_addify_rfq_cart', enforceSingleQuantity);

});



// Formulaire de contact - demande devis
document.addEventListener('DOMContentLoaded', () => {
    // Vérifie que l'on est sur la page avec la bonne ID
    if(document.body.classList.contains('page-id-811')) {

        // Récupère l'URL actuelle
        const urlParams = new URLSearchParams(window.location.search);
        const produit = urlParams.get('produit'); // récupère ?produit=
        if(!produit) return;

        // On attend que l'input existe
        const waitForInput = setInterval(() => {
            const input = document.querySelector('#nf-field-16');
            if(input) {
                input.value = decodeURIComponent(produit);
                clearInterval(waitForInput); // stop l'interval
            }
        }, 100); // vérifie toutes les 100ms
    }

});




// Regle - Switch modèles
const swatchesContainer = document.querySelector('.thwvsf-wrapper-ul');

if (swatchesContainer) {
    swatchesContainer.addEventListener('click', (e) => {

        console.log("clique modele");


        const swatch = e.target.closest('.thwvsf-wrapper-item-li');
        if (!swatch) return;

        const img = swatch.querySelector('img');
        if (!img) return;

        // Récupération de l'image grande résolution
        const newImage =
            img.getAttribute('data-full_src') ||
            img.getAttribute('data-large_image') ||
            img.getAttribute('data-src') ||
            img.getAttribute('src'); // fallback

        const mainImage = document.querySelector('.woocommerce-product-gallery__image img');
        const mainWrapper = document.querySelector('.woocommerce-product-gallery__image a');



        // Mise à jour de la première miniature
        const gallery = jQuery('.woocommerce-product-gallery');
        gallery.find('.flex-control-thumbs li:first-child img').each(function() {
           jQuery('.flex-control-thumbs li:first-child img').attr('src', newImage);
            jQuery('.flex-control-thumbs li:first-child img').attr('srcset', newImage);
            jQuery('.flex-control-thumbs li:first-child img').data('large_image', newImage);

        });


        // Met à jour la gallery WC (zoom/slider)
       jQuery('.woocommerce-product-gallery').trigger('wc_product_gallery_reset_slider');



        // Force le slider sur la première image
        setTimeout(() => {
            jQuery('.woocommerce-product-gallery').flexslider(0);

            if (mainImage) {
                mainImage.src = newImage;
                mainImage.srcset = newImage;
                mainImage.dataset.large_image = newImage;
            }

            if (mainWrapper) {
                mainWrapper.href = newImage;
            }

        }, 0);

    });
}


// Panier count
document.addEventListener('DOMContentLoaded', () => {
    const totalItemsSpan = document.getElementById('total-items-count');

    if (totalItemsSpan) {
        // Récupère le texte et convertit en nombre
        const totalItems = parseInt(totalItemsSpan.textContent.trim(), 10);
        const account = document.getElementById('account');
        console.log('Total items:', totalItems); // Affiche juste le nombre


            if (!isNaN(totalItems) && totalItems > 0) {
                account.classList.add('active');
                console.log("oui");
            } else {
                account.classList.remove('active');
            }

    }
});

// Gestion cookies
document.addEventListener('DOMContentLoaded', () => {
const gestionCookies = document.querySelector('.gestionCookies');

// Vérifie que l'élément existe
    if (gestionCookies) {
        gestionCookies.addEventListener('click', () => {
            // Sélectionne le bouton cky-btn-revisit
            const btnRevisit = document.querySelector('.cky-btn-revisit');
            if (btnRevisit) {
                btnRevisit.click(); // déclenche le clic
            }
        });
    }
});

// Produit - Read more mobile

document.addEventListener("DOMContentLoaded", function () {

    const longDescription = document.querySelector(".woocommerce-product-details__long-description-desc");
    const readMore = document.querySelector(".mobile-read-more");


    readMore.addEventListener("click", function() {
        readMore.classList.add("active");
        longDescription.classList.add("active");
    });

});

// Header menu solutions - Menu au clique sur desktop

document.addEventListener("DOMContentLoaded", function () {

    const items = document.querySelectorAll('.nav > li');
    const modalMenu = document.querySelector('#modalMenu');
    const closeMenu = document.querySelectorAll('.closeMenu');


    items.forEach(li => {

        li.addEventListener('click', function (e) {

            const link = li.querySelector(':scope > a');

            // 👉 si clic dans submenu → on ignore totalement le handler du li
            if (e.target.closest('.submenu')) {
                return;
            }

            // annule navigation lien parent
            if (e.target.closest('a') === link) {
                e.preventDefault();
            }

            const isAlreadyActive = li.classList.contains('active-menu');

            // ferme tous les menus
            items.forEach(other => {
                other.classList.remove('active-menu');
                modalMenu.classList.remove('open');
            });

            // toggle logique correcte
            if (!isAlreadyActive) {
                li.classList.add('active-menu');
                modalMenu.classList.add('open');
            }
        });


        modalMenu.addEventListener('click', function (e) {
            items.forEach(other => {
                other.classList.remove('active-menu');
            });
        });

        closeMenu.forEach(button => {
            button.addEventListener('click', function (e) {
                items.forEach(other => {
                    other.classList.remove('active-menu');
                });

                modalMenu.classList.remove('open');
            });
        });

    });

});


// Header solutions : comportement au scroll

document.addEventListener("DOMContentLoaded", function () {

    const header = document.querySelector('#headernav');
    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', function () {

        const currentScrollY = window.scrollY;

        // 👉 tant qu'on n'a pas scrollé 100px, on ne fait rien
        if (currentScrollY < 100) {
            header.classList.remove('inactive');
            lastScrollY = currentScrollY;
            return;
        }

        if (Math.abs(currentScrollY - lastScrollY) < 5) return;

        if (currentScrollY > lastScrollY) {
            header.classList.add('inactive');
        } else {
            header.classList.remove('inactive');
        }

        lastScrollY = currentScrollY;
    });

});